import { useState } from 'react';

import { DialogProps } from '@cast/design-system';
import { K8sProvider } from '@cast/shared-types';
import { Cluster } from '@cast/types';

import { FeatureName, FeatureSelection } from 'hooks/dialogs/cluster/types';
import { notReachable } from 'utils/types/not-reachable';

import { LegacyOnboardClusterDialog } from './LegacyOnboardClusterDialog';
import { CastctlOnboardClusterDialog } from '../components/CastctlOnboardingDialog';

type DialogVariant = 'castctl' | 'legacy';

type Props = Omit<DialogProps, 'onClose'> & {
  initialProvider: K8sProvider;
  initialAnywhereClusterName?: string;
  promotedFeature?: FeatureName;
  onClose: () => void;
  onCompleted: () => void;
  onClusterConnected: (cluster: Cluster) => void;
  onFeaturesSelected: (features: FeatureSelection) => void;
};

export const ClusterOnboardingDialog = ({
  initialProvider,
  initialAnywhereClusterName,
  promotedFeature,
  onClose,
  onCompleted,
  onClusterConnected,
  onFeaturesSelected,
  ...dialogProps
}: Props) => {
  const [variant, setVariant] = useState<DialogVariant>('castctl');

  switch (variant) {
    case 'castctl':
      return (
        <CastctlOnboardClusterDialog
          onClose={onClose}
          onCompleted={onCompleted}
          onClusterConnected={onClusterConnected}
          onFeaturesSelected={onFeaturesSelected}
          onSwitchToLegacyScript={() => setVariant('legacy')}
          {...dialogProps}
        />
      );
    case 'legacy':
      return (
        <LegacyOnboardClusterDialog
          initialProvider={initialProvider}
          initialAnywhereClusterName={initialAnywhereClusterName}
          promotedFeature={promotedFeature}
          onClose={onClose}
          onCompleted={onCompleted}
          onClusterConnected={onClusterConnected}
          onFeaturesSelected={onFeaturesSelected}
          onSwitchToCastctl={() => setVariant('castctl')}
          {...dialogProps}
        />
      );
    default:
      return notReachable(variant);
  }
};
